export const DECORATING_LOCATIONS = [
  { id: 1, name: 'Neckline & arms' },
  { id: 2, name: 'Neckline, hood, shoulders, arms, bottom, & hoodie pocket' },
  { id: 3, name: 'Neckline & arms & bottom' },
  { id: 4, name: 'Half hood' },
  { id: 5, name: 'Full hood' },
  { id: 6, name: 'Sleeve stripes' },
  { id: 7, name: 'Sleeve and front stripes' },
  { id: 8, name: 'Leg Stripes' },
  { id: 9, name: 'Side Stripes' },
  { id: 10, name: 'Neckline, bottom & straps' },
  { id: 11, name: 'Both Sleeves' },
  { id: 12, name: 'Single Sleeve' },
  { id: 13, name: 'Across chest without sleeve locations' },
];

export const DECORATING_METHODS = [
  {
    name: 'Cover Stitches',
    id: 1,
    imageSrc: '/src/assets/svg/decoratings/cover.png',
    sImageSrc: '/src/assets/svg/decoratings/cover.png',
  },
  {
    name: 'Hood Stitch',
    id: 2,
    imageSrc: '/src/assets/svg/decoratings/hood.png',
    sImageSrc: '/src/assets/svg/decoratings/hood.png',
  },
  {
    name: 'Lace',
    id: 3,
    imageSrc: '/src/assets/svg/decoratings/lace.png',
    sImageSrc: '/src/assets/svg/decoratings/lace.png',
  },
  {
    name: 'Stripes',
    id: 4,
    imageSrc: '/src/assets/svg/decoratings/stripes.png',
    sImageSrc: '/src/assets/svg/decoratings/stripes.png',
  },
  {
    name: 'Studs',
    id: 5,
    imageSrc: '/src/assets/svg/decoratings/studs.png',
    sImageSrc: '/src/assets/svg/decoratings/studs.png',
  },
  {
    name: 'Bow',
    id: 6,
    imageSrc: '/src/assets/svg/decoratings/bows.png',
    sImageSrc: '/src/assets/svg/decoratings/bows.png',
  },
  {
    name: 'Rosettes',
    id: 7,
    imageSrc: '/src/assets/svg/decoratings/rosettes.png',
    sImageSrc: '/src/assets/svg/decoratings/rosettes.png',
  },
  {
    name: 'Custom Names',
    id: 8,
    imageSrc: '/src/assets/svg/decoratings/names.png',
    sImageSrc: '/src/assets/svg/decoratings/names.png',
  },
  {
    name: 'Custom Numbers',
    id: 9,
    imageSrc: '/src/assets/svg/decoratings/numbers.png',
    sImageSrc: '/src/assets/svg/decoratings/numbers.png',
  },
];

export const OLD_DECORATING_METHODS = [
  {
    type: 'Cover Stitches',
    value: 1,
    imageSrc: '/src/assets/svg/print-decor-types/cover-stitch.webp',
    sImageSrc: '/src/assets/svg/print-decor-types/cover-stitch.webp',
  },
  {
    type: 'Irving Stitch',
    value: 2,
    imageSrc: '/src/assets/svg/print-decor-types/irving-stitch.webp',
    sImageSrc: '/src/assets/svg/print-decor-types/irving-stitch.webp',
  },
  {
    type: 'Studs',
    value: 3,
    imageSrc: '/src/assets/svg/print-decor-types/studs.webp',
    sImageSrc: '/src/assets/svg/print-decor-types/studs.webp',
  },
  {
    type: 'Bows',
    value: 4,
    imageSrc: '/src/assets/svg/print-decor-types/bows.webp',
    sImageSrc: '/src/assets/svg/print-decor-types/bows.webp',
  },
  {
    type: 'Rosettes',
    value: 5,
    imageSrc: '/src/assets/svg/print-decor-types/rosettes.webp',
    sImageSrc: '/src/assets/svg/print-decor-types/rosettes.webp',
  },
  {
    type: 'Fabric Stripes',
    value: 6,
    imageSrc: '/src/assets/svg/print-decor-types/fabric_stripes.webp',
    sImageSrc: '/src/assets/svg/print-decor-types/fabric_stripes.webp',
  },
  {
    type: 'Lace',
    value: 7,
    imageSrc: '/src/assets/svg/print-decor-types/lace.webp',
    sImageSrc: '/src/assets/svg/print-decor-types/lace.webp',
  },
];

export const LACE_DECORATING_METHOD_ID = 3;

/**
 * Fallback CMS uids for "Patterns and/or Colorblock" until `GET /api/v4/print-config` loads.
 * Quoting and pills read live ids from PrintConfigPatternIdsUtils.
 */
export const PATTERNS_AND_COLORBLOCK_METHOD_ID = 11;

/** Fallback treatments inside {@link PATTERNS_AND_COLORBLOCK_METHOD_ID}. */
export const COLOR_BLOCK_TREATMENT_ID = 8;
export const CUSTOM_PATTERN_TREATMENT_ID = 9;
export const PATTERNS_AND_COLORBLOCK_TREATMENT_IDS = [
  COLOR_BLOCK_TREATMENT_ID,
  CUSTOM_PATTERN_TREATMENT_ID,
];

/** Fallback placement used when a pattern covers the whole garment. */
export const FULL_GARMENT_PLACEMENT_ID = 86;

export const LACE_MTO_COLOR = [
  'White Made-to-Order',
  'White 2 Made-to-Order',
  'Peach Made-to-Order',
  'Black Made-to-Order',
];
